import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {

  constructor(private route: ActivatedRoute, private auth: AuthService) {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      //TODO: FIx
      // this.auth.tokenAuth(token);
    } else {
      console.error('No token provided');
    }
  }

  ngOnInit(): void {}
}
